import React, { useState } from 'react';
import { Button, Form, FormInstance, Space } from 'antd';
import { Drawer, PrimaryButton } from '@common/components';
import { useMutation } from '@common/hooks';
import { updateWorksProfileAction } from './works-profile-helper';
import { CandidateForm } from '.';
import { UpdateWorksProfile } from '@clinician-profile/graphql';
import { Store } from 'antd/lib/form/interface';

const Footer = ({
  onClose,
  form,
  loading,
}: {
  onClose: () => void;
  form: FormInstance;
  loading: boolean;
}) => (
  <Space>
    <Button size="large" key="back" onClick={onClose}>
      Cancel
    </Button>
    <PrimaryButton loading={loading} size="large" onClick={form.submit}>
      Update Profile
    </PrimaryButton>
  </Space>
);

export function UpdateCandidateDrawer({
  open,
  onClose,
  worksProfileId,
}: {
  open: boolean;
  onClose: () => void;
  worksProfileId?: string;
}) {
  const [form] = Form.useForm();

  const [formSubmitting, setFormSubmitting] = useState(false);

  const onCloseDrawer = () => {
    form.resetFields();
    onClose();
  };

  const [updateWorksProfile] = useMutation(
    UpdateWorksProfile,
    updateWorksProfileAction(form, onCloseDrawer)
  );

  const onFinish = (values: Store) => {
    setFormSubmitting(true);

    const worksProfileInput = {
      input: {
        profileType: values.profileType,
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        dateOfBirth: values.dateOfBirth,
        profileSummary: values.profileSummary,
        ssn: values.ssn?.length ? values.ssn : undefined,
        phone: values.phone,
        roleId: values.roleId,
        primarySpecialtyId: values.specialtyId,
        secondarySpecialtyIds: values.secondarySpecialtyIds,
      },
    };

    updateWorksProfile({
      variables: {
        id: worksProfileId,
        ...worksProfileInput,
      },
    }).then(() => setFormSubmitting(false));
  };

  return (
    <Drawer
      open={open}
      title="Edit Candidate"
      onClose={onCloseDrawer}
      footer={
        <Footer loading={formSubmitting} onClose={onCloseDrawer} form={form} />
      }
    >
      <CandidateForm
        form={form}
        onFinish={onFinish}
        worksProfileId={worksProfileId}
        formSubmitting={formSubmitting}
      />
    </Drawer>
  );
}
